module.exports = __webpack_public_path__ + "media/images/Amsale-WGE-2053789f.webp";